import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { Colors } from "../../../../configs";

export interface IPickupDetailsSectionProps {
  totalInvoices: number;
  totalPrice: number;
  totalDiscounts: number;
  totalDue: number;
}

const PickupDetailsSection: FC<IPickupDetailsSectionProps> = ({
  totalInvoices,
  totalPrice,
  totalDiscounts,
  totalDue,
}) => {
  const stats = [
    { label: "Total Invoices", value: `${totalInvoices}` },
    { label: "Total Price", value: `$${totalPrice.toFixed(2)}` },
    { label: "Discounts", value: `$${totalDiscounts.toFixed(2)}` },
    {
      label: "Balance Due",
      value: `$${totalDue.toFixed(2)}`,
      color: Colors.BROWN,
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "0.75rem",
      }}
    >
      {stats.map((stat) => (
        <Box key={stat.label}>
          <Typography
            sx={{
              fontSize: "0.72rem",
              fontWeight: 600,
              whiteSpace: "nowrap",
              color: `${Colors.MAIN_GRAY}99`,
            }}
          >
            {stat.label}
          </Typography>
          <Typography
            sx={{
              mt: "0.15rem",
              fontSize: "1.2rem",
              fontWeight: "bold",
              whiteSpace: "nowrap",
              color: stat.color ?? Colors.MAIN_GRAY,
            }}
          >
            {stat.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default PickupDetailsSection;
